import PT from 'prop-types';
import cx from 'classnames';
import style from './styles.scss';

const Container = ({ wide, children }) => {
  return (
    <section
      className={cx(style.container, {
        [style.wide]: wide,
      })}
    >
      {children}
    </section>
  );
};

export default Container;

Container.propTypes = {
  children: PT.node.isRequired,
  wide: PT.bool,
};
